import {
  createClient,
  DeleteOperation,
  deleteRequestFactory,
  FindOperation,
  getRequestFactory,
  putRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';
import { LocalAuthChargingStation, UpdateLocalAuthChargingStation } from './model';

const client = createClient('/rest/authorization/local/charging-stations');

export const localChargingStationPermissions = {
  SEARCH: 'cpms.search-local-charging-stations',
  GET: 'cpms.get-local-charging-station',
  UPDATE: 'cpms.update-local-charging-station',
  DELETE: 'cpms.delete-local-charging-station'
};

export const searchLocalAuthChargingStations: SearchOperation<LocalAuthChargingStation> = searchRequestFactory<LocalAuthChargingStation>(
  client,
  {
    permissionId: localChargingStationPermissions.SEARCH
  }
);

export const getLocalAuthChargingStation: FindOperation<LocalAuthChargingStation, string> = getRequestFactory<
  LocalAuthChargingStation,
  string
>(client, {
  permissionId: localChargingStationPermissions.GET
});

export const updateLocalAuthChargingStation: SaveOperation<UpdateLocalAuthChargingStation, LocalAuthChargingStation, string> =
  putRequestFactory<UpdateLocalAuthChargingStation, LocalAuthChargingStation, string>(client, {
    pattern: '/{id}',
    permissionId: localChargingStationPermissions.UPDATE
  });

export const deleteLocalAuthChargingStation: DeleteOperation<void, string> = deleteRequestFactory<void, string>(client, {
  permissionId: localChargingStationPermissions.DELETE
});
